import axios from "axios";
import React, { useEffect, useState } from "react";
import Loading from "../../components/Main/Loading";
import NotificationPage from "../../components/Notification/NotificationPage";
import ToastError from "../../components/Notification/ToastError";
import { authsignature, storage } from "../../libs";

function Notification() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadPage, setLoadPage] = useState(false);
  const [isMore, setMore] = useState(false);

  const limit = "10";
  const [offset, setOffset] = useState("0");

  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const onError = () => {
    setOpen(false);
  };

  const GetData = async () => {
    setLoading(true);
    const auth = await storage();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/notif`,
        { offset: "0", limit, read: "0" },
        {
          headers: await authsignature(auth.token, {
            offset: "0",
            limit,
            read: "0",
          }),
        }
      );

      if (Number(response.data.code) === 200) {
        setData(response.data.data);

        if (response.data.data.length > 9) {
          setMore(true);
        } else {
          setMore(false);
        }
      } else {
        setOpen(true);
        setResponse("");
      }
      setLoading(false);
    } catch (e) {
      setOpen(true);
      setResponse("");

      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onRead = async (data) => {
    try {
      const auth = await storage();
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/notif-read`,
        { notif_id: "0" },
        {
          headers: await authsignature(auth.token, { notif_id: "0" }),
        }
      );

      if (Number(response.data.code) === 200) {
        setData([]);
      } else {
        setOpen(true);
        setResponse("");
      }
    } catch (e) {
      setOpen(true);
      setResponse("");
    }
  };

  const onPage = async () => {
    setLoadPage(true);
    const auth = await storage();

    try {
      const pages = 10 + Number(offset);
      setOffset(pages.toString());

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/notif`,
        { offset: pages.toString(), limit, read: "0" },
        {
          headers: await authsignature(auth.token, {
            offset: pages.toString(),
            limit,
            read: "0",
          }),
        }
      );

      if (Number(response.data.code) === 200) {
        let dataPush = [...data];
        dataPush.push(response.data.data);

        dataPush = dataPush.flat();
        dataPush = dataPush.filter(
          (v, i, a) => a.findIndex((t) => t.id === v.id) === i
        );
        setData(dataPush);

        if (response.data.data.length > 9) {
          setMore(true);
        } else {
          setMore(false);
        }
      } else {
        setOpen(true);
        setResponse("");
      }
      setLoadPage(false);
    } catch (e) {
      setOpen(true);
      setResponse("");

      setLoadPage(false);
    }
  };

  return (
    <>
      <ToastError props={{ open, response, onError }} />
      {loading ? (
        <Loading />
      ) : (
        <NotificationPage props={{ data, onRead, onPage, loadPage, isMore }} />
      )}
    </>
  );
}

export default Notification;
